"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../utils/constants");
var muiStarFill16 = {
    paths: [
        {
            path: 'M5.25769325,5.01032964 L7.31012368,0.930813298 C7.43140093,0.676319936 7.69471004,0.5 8,0.5 C8.30528996,0.5 8.56859907,0.676319936 8.68987632,0.930813298 L10.7423067,5.01032964 L15.3316807,5.66451051 C15.6158917,5.69901368 15.8682029,5.8901828 15.9625427,6.17500393 C16.0568825,6.45982506 15.9673052,6.75996589 15.7580477,6.95175461 L12.4371455,10.1272152 L12.4371455,10.1272152 L13.2211042,14.6110376 C13.275479,14.8868551 13.1681068,15.181324 12.921122,15.3573532 C12.6741372,15.5333823 12.3554664,15.5425596 12.1048609,15.4065982 L8,13.2896244 L3.89513914,15.4065982 C3.64453364,15.5425596 3.32586276,15.5333823 3.078878,15.3573532 C2.83189323,15.181324 2.72452101,14.8868551 2.77889581,14.6110376 L3.56285447,10.1272152 L0.241952282,6.95175461 C0.0326947668,6.75996589 -0.0568824518,6.45982506 0.0374573341,6.17500393 C0.13179712,5.8901828 0.384108319,5.69901368 0.668319294,5.66451051 L5.25769325,5.01032964 L5.25769325,5.01032964 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Star',
    width: 16,
    height: 16,
};
var muiStarFill24 = {
    paths: [
        {
            path: 'M7.88653988,7.41583878 L10.9651855,1.16058039 C11.1471014,0.770357236 11.5420651,0.5 12,0.5 C12.4579349,0.5 12.8528986,0.770357236 13.0348145,1.16058039 L16.1134601,7.41583878 L22.9975211,8.41891611 C23.4238375,8.47182098 23.8023043,8.76494696 23.943814,9.20167269 C24.0853237,9.63839842 23.9509578,10.0986144 23.6370716,10.3926904 L18.6557183,15.26173 L18.6557183,15.26173 L19.8316563,22.1369243 C19.9132185,22.5598445 19.7521602,23.0113635 19.381683,23.2812749 C19.0112059,23.5511862 18.5331995,23.5652581 18.1572913,23.3567839 L12,20.1107575 L5.84270871,23.3567839 C5.46680046,23.5652581 4.98879414,23.5511862 4.61831699,23.2812749 C4.24783984,23.0113635 4.08678152,22.5598445 4.16834372,22.1369243 L5.34428171,15.26173 L0.362928423,10.3926904 C0.0490421503,10.0986144 -0.0853236777,9.63839842 0.0561860011,9.20167269 C0.19769568,8.76494696 0.576162479,8.47182098 1.00247894,8.41891611 L7.88653988,7.41583878 L7.88653988,7.41583878 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Star',
    width: 24,
    height: 24,
};
var muiStarFill = {
    base: muiStarFill16,
    smIcon: muiStarFill16,
    lgIcon: muiStarFill24,
};
exports.muiStarFill = muiStarFill;
//# sourceMappingURL=starFill.js.map